import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyLionMode({ Copy }: ModeRendererProps) {
  const idBase = React.useMemo(() => {
    try {
      const url = typeof window !== "undefined" ? new URL(window.location.href) : null;
      const param = url
        ? url.searchParams.get("id") || url.searchParams.get("uid") || url.searchParams.get("modeId") || url.searchParams.get("mode_id")
        : null;
      return param ? `lion_${param}` : `lion_${Math.random().toString(36).slice(2, 8)}`;
    } catch {
      return `lion_${Math.random().toString(36).slice(2, 8)}`;
    }
  }, []);

  return (
    <g>
      <rect width={794} height={1123} fill="#F6E7C1" />
      {/* mane ring */}
      <circle cx={397} cy={420} r={160} fill="#D99A3A" opacity={0.9} />
      <circle cx={397} cy={420} r={100} fill="#FFD89A" />
      <g className="mode-copy" transform="translate(48,840)" fill="#3b2f2b">
        <text x={0} y={0} fontSize={18} fontWeight={700}>{Copy?.title}</text>
        <text x={0} y={22} fontSize={14}>{Copy?.subtitle}</text>
      </g>
    </g>
  );
}

export default VasarelyLionMode;
